function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSlackColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 24 24.01"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M5.06 15.18a2.52 2.52 0 1 1-2.52-2.52h2.52Zm1.26 0a2.52 2.52 0 0 1 5 0v6.31a2.52 2.52 0 0 1-5 0Z",
  style: {
    fill: "#e11f5b"
  },
  transform: "translate(0 -.01)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.84 5.05a2.52 2.52 0 1 1 2.52-2.52v2.52Zm0 1.29a2.52 2.52 0 0 1 0 5H2.52a2.52 2.52 0 0 1 0-5Z",
  style: {
    fill: "#44c0eb"
  },
  transform: "translate(0 -.01)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.94 8.86a2.52 2.52 0 1 1 2.52 2.52h-2.52Zm-1.26 0a2.52 2.52 0 0 1-5 0V2.53a2.52 2.52 0 0 1 5 0Z",
  style: {
    fill: "#3ab07c"
  },
  transform: "translate(0 -.01)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.16 19a2.52 2.52 0 1 1-2.52 2.52V19Zm0-1.26a2.53 2.53 0 0 1 0-5.05h6.32a2.53 2.53 0 0 1 0 5.05Z",
  style: {
    fill: "#ecb22c"
  },
  transform: "translate(0 -.01)"
}));
export { SvgSlackColor as ReactComponent };
export default __webpack_public_path__ + "static/media/slackColor.cb4969c4.svg";